const trainingModules = [
  {
    id: "orientation",
    title: "New Ranger Orientation",
    duration: "12 min",
    focus: "Core Policies",
    summary:
      "Review onboarding essentials, safety protocols, and uniform standards for every Ranger on duty.",
    level: "Required",
    provider: "highway",
  },
  // ── REGULAR TRACK: Foundations & Field Skills ──────────────
  {
    id: "safety-service-patrols",
    title: "Safety Service Patrols: An Underutilized Partner",
    focus: "Responder Safety",
    summary:
      "An introduction to Safety Service Patrols covering awareness-level operations, recommended vehicle outfitting, and roadway operating procedures for SSPs.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Safety_Service_Patrols_An_Underutilized_Partner.aspx",
  },
  {
    id: "tim-next-generation",
    title: "TIM For The Next Generation",
    focus: "Responder Safety",
    summary:
      "An introduction to traffic incident management designed for first responders who are newer to the profession.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/TIM_For_The_Next_Generation.aspx",
  },
  {
    id: "ppe-roadway",
    title: "Personal Protective Equipment for Roadway Incident Response",
    focus: "Responder Safety",
    summary:
      "Learn PPE requirements and how to select, correctly wear, and consistently use protective equipment to mitigate the hazards of working roadway incidents.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/PPE-for-Roadway-Incident-Response.aspx",
  },
  {
    id: "helmets-head-protection",
    title: "Helmets and Head Protection for Roadway Incidents 2025",
    focus: "Responder Safety",
    summary:
      "Understand helmet parameters, design standards, and evaluation criteria for head protection used in roadway incident response.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Helmets-and-Head-Protection-2025.aspx",
  },
  {
    id: "high-visibility-innovations",
    title: "High Visibility Innovations",
    image: "training/highvisibility.jpg",
    focus: "Responder Safety",
    summary:
      "Explore standards and emerging products that improve responder visibility across fire, police, EMS, DOT, and towing operations.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/High_Visibility_Innovations.aspx",
  },
  {
    id: "lighting-awareness",
    title: "See and Be Seen: Emergency Lighting Awareness",
    image: "training/seenandbeseen.jpg",
    focus: "Responder Safety",
    summary:
      "Review best practices for deploying emergency lighting and what research suggests about effective warning characteristics.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/See_and_Be_Seen_Emergency_Lighting_Awareness.aspx",
  },
  {
    id: "advance-warning",
    title: "Advance Warning",
    image: "training/advancewarning.jpg",
    focus: "Responder Safety",
    summary:
      "Discuss the concept of advance warning, its benefits, and how to deploy appropriate devices when building your agency's roadway response plans.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Advance_Warning.aspx",
  },
  {
    id: "blocking-procedures",
    title: "Blocking Procedures at Roadway Incidents",
    image: "training/blockingprocedures.jpg",
    focus: "Responder Safety",
    summary:
      "Examine safe parking and positioning, when to use linear versus angled blocks, and the steps to protect crews during diverse roadway incidents.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Blocking.aspx",
  },
  {
    id: "manual-traffic-control",
    title: "Manual Traffic Control",
    focus: "Responder Safety",
    summary:
      "Build the foundation for successful manual traffic control with recommended procedures for safely and effectively directing traffic at incident scenes.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Manual-Traffic-Control.aspx",
  },
  {
    id: "mutcd",
    title: "Manual on Uniform Traffic Control Devices",
    image: "training/manualonuniformtraffic.jpg",
    focus: "Responder Safety",
    summary:
      "Translate key MUTCD provisions for temporary traffic control zones and understand their impact on roadway incident response.",
    level: "Advanced",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Manual_on_Uniform_Traffic_Control_Devices_MUTCD.aspx",
  },
  {
    id: "innovative-ttc-devices",
    title: "Innovative Temporary Traffic Control Devices & Methods",
    focus: "Responder Safety",
    summary:
      "Discover new devices, technologies, and methods for temporary traffic control so your team can evaluate whether to adopt them in the field.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Innovative_Temporary_Traffic_Control_Devices_Methods.aspx",
  },
  {
    id: "first-15-minutes",
    title: "The First 15 Minutes at Roadway Incidents",
    focus: "Responder Safety",
    summary:
      "Learn the critical actions first-arriving emergency response personnel should take when they reach an incident on the roadway.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/The_First_15_Minutes_at_Roadway_Incidents.aspx",
  },
  {
    id: "move-it-work-it",
    title: "Move It or Work It",
    image: "training/moveitorworkit.jpg",
    focus: "Responder Safety",
    summary:
      "Apply a structured decision model for safe, quick clearance while aligning with National Unified Goal policies and local MOUs.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Move_It_or_Work_It.aspx",
  },
  {
    id: "scene-control",
    title: "Scene Control",
    focus: "Responder Safety",
    summary:
      "Address the challenges created when bystanders, media, and other non-responders are present at a roadway incident scene.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Scene_Control.aspx",
  },
  {
    id: "national-unified-goal",
    title: "National Unified Goal for Traffic Incident Management",
    focus: "Responder Safety",
    summary:
      "Explore the National Unified Goal as the road map for implementing cross-department cooperation and communication in traffic incident management.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/National_Unified_Goal_for_Traffic_Incident_Management.aspx",
  },
  {
    id: "vehicle-fires",
    title: "Special Circumstances: Safe Operations for Vehicle Fires",
    image: "training/specialcircumstances.jpg",
    focus: "Responder Safety",
    summary:
      "Address PPE, blocking, hazard assessment, and termination considerations unique to vehicle fire incidents on the roadway.",
    level: "Advanced",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Special_Circumstances_Safe_Operations_for_Vehicle_Fires.aspx",
  },
  {
    id: "lodds-roadway",
    title: "LODDs on the Roadway: Safety Lessons Learned",
    focus: "Responder Safety",
    summary:
      "Review NIOSH reports on line-of-duty deaths at roadway incidents and extract critical safety lessons for everyday operations.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/LODDs_on_the_Roadway_Safety_Lessons_Learned.aspx",
  },
  {
    id: "termination",
    title: "Termination",
    image: "training/termination.jpg",
    focus: "Responder Safety",
    summary:
      "Detail the final tasks of roadway incident response, emphasizing crew safety and situational awareness during scene demobilization.",
    level: "Core",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Termination.aspx",
  },
  {
    id: "tim-rural-roads",
    title: "Traffic Incident Management on Rural Roads",
    focus: "Responder Safety",
    summary:
      "Address the unique challenges of traffic incident management on rural roadways, including limited resources, extended response times, and remote scene safety.",
    level: "Elective",
    provider: "responder",
    track: "regular",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Traffic_Incident_Management_on_Rural_Roads.aspx",
  },
  // ── LEADER TRACK: Command, Standards & Policy ──────────────
  {
    id: "tim-ics",
    title: "Traffic Incident Management: Incident Command & Management",
    image: "training/incidentcommand.jpg",
    focus: "Responder Safety",
    summary:
      "Connect Incident Command System policy decisions to roadway environments and clarify responder roles within temporary traffic control zones.",
    level: "Advanced",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Traffic_Incident_Management_Incident_Command_Management.aspx",
  },
  {
    id: "whos-in-charge",
    title: "Who's In Charge at Roadway Incident Scenes?",
    focus: "Responder Safety",
    summary:
      "Explore unified command concepts, authority hierarchies, and multi-agency coordination to clarify leadership roles at roadway incident scenes.",
    level: "Elective",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Whos_In_Charge_at_Roadway_Incident_Scenes.aspx",
  },
  {
    id: "professionalism-leadership",
    title: "Professionalism and Leadership in Roadway Incident Response",
    focus: "Responder Safety",
    summary:
      "Develop professional conduct and leadership skills essential for effective, respected, and coordinated roadway incident response.",
    level: "Elective",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Professionalism_and_Leadership_in_Roadway_Incident_Response.aspx",
  },
  {
    id: "tim-model-practices",
    title: "Traffic Incident Management: Model Practices & Procedures",
    focus: "Responder Safety",
    summary:
      "Discover model policies, practices, and procedures for key TIM topics, from pre-planning to incident response and through to after-action review.",
    level: "Elective",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Traffic_Incident_Management_Model_Practices__Procedures.aspx",
  },
  {
    id: "tim-sops",
    title: "Recommended Practices for TIM SOPs",
    focus: "Responder Safety",
    summary:
      "Learn best practices for standardizing traffic incident management operating procedures across jurisdictions and geographic areas.",
    level: "Elective",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Recommended_Practices_for_TIM_SOPs.aspx",
  },
  {
    id: "tim-nfpa-1550",
    title: "Traffic Incident Management Requirements in NFPA 1550",
    focus: "Responder Safety",
    summary:
      "Review NFPA 1550 requirements related to traffic incident management and understand how they apply to responder safety operations on the roadway.",
    level: "Advanced",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/TIM-Requirements-in-NFPA-1550.aspx",
  },
  {
    id: "nfpa-1091",
    title: "Understanding NFPA 1091",
    focus: "Responder Safety",
    summary:
      "Understand the NFPA 1091 standard for traffic control incident management professional qualifications and certification pathways.",
    level: "Advanced",
    provider: "responder",
    track: "leader",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Understanding_the_New_NFPA_1091.aspx",
  },
  // ── DISASTER TRACK: Hazards, Weather & Extended Ops ────────
  {
    id: "special-hazards",
    title: "Special Hazards",
    image: "training/specialhazards.jpg",
    focus: "Responder Safety",
    summary:
      "Prepare for HAZMAT, medical helicopter, vehicle extrication, and crash investigation impacts on traffic incident management.",
    level: "Elective",
    provider: "responder",
    track: "disaster",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Special_Hazards.aspx",
  },
  {
    id: "tim-weather-events",
    title: "TIM Techniques for Weather Events",
    focus: "Responder Safety",
    summary:
      "Learn traffic incident management strategies for safely operating during severe weather, including reduced visibility, icy surfaces, and hazardous road conditions.",
    level: "Elective",
    provider: "responder",
    track: "disaster",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/TIM-Techniques-for-Weather-Events.aspx",
  },
  {
    id: "planning-long-term",
    title: "Planning for the Long-Term Event",
    focus: "Responder Safety",
    summary:
      "Gain guidance for jurisdictions and TIM teams to plan for long-term events, including resource management and sustained operations.",
    level: "Elective",
    provider: "responder",
    track: "disaster",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Planning_for_the_Long-Term_Event.aspx",
  },
  {
    id: "wildland-fires",
    title: "Wildland Fires and Traffic Management",
    focus: "Responder Safety",
    summary:
      "Learn safety procedures for operating near roadways affected by wildland fires and when vehicles and firefighters are in close proximity off-road.",
    level: "Elective",
    provider: "responder",
    track: "disaster",
    creditHours: 1,
    url: "https://learning.respondersafety.com/Training_Programs/Wildland-Fires-and-Traffic-Management.aspx",
  },
  {
    id: "national-highway-ranger",
    title: "National Highway Ranger",
    focus: "Mastery Certification",
    summary:
      "Deploy beyond Texas with confidence through national standards alignment, adaptive response practices, and multi-state hazard readiness.",
    level: "Mastery",
    provider: "highway",
    requirements: {
      intro:
        "Prepares Rangers for safe, confident, and effective operations beyond Texas, in unfamiliar roadway environments and varying state-level protocols.",
      sections: [
        {
          title: "Core Curriculum",
          body:
            "Complete all Core and Required Ranger Academy modules to ensure foundational readiness before traveling outside the state.",
        },
        {
          title: "Interstate & Out-of-State Operations",
          body:
            "Master advanced topics including multi-jurisdictional response etiquette, interstate safety protocols, variable weather/terrain considerations, and roadway infrastructure differences across the U.S.",
        },
        {
          title: "Adaptive Response Practices",
          body:
            "Demonstrate proficiency with dynamic routing, low-visibility hazard management, and long-distance operational planning in unfamiliar territory.",
        },
        {
          title: "National Standards Alignment",
          body: "Upload or complete certifications reflecting broader national practices, such as:",
          bullets: [
            "FHWA-approved TIM training (national edition)",
            "NIMS compliant ICS for field responders",
            "Region-specific hazard awareness (mountain, desert, coastal, snow-belt, etc.)",
          ],
        },
        {
          title: "Special Initiatives",
          body: "Submit validated training for:",
          bullets: [
            "Interstate Incident Safety (advanced)",
            "Multi-State Hazard Awareness",
            "Travel Ranger Readiness course",
          ],
        },
      ],
    },
  },
  {    id: "disaster-response-ranger",
    title: "Disaster Response Ranger",
    image: "training/rrt.png",
    focus: "Mastery Certification",
    summary:
      "Deploy to disaster sites with confidence through FEMA incident command mastery, inter-agency coordination, and all-hazards operational readiness. This certification validates that you can integrate into large-scale disaster response operations and represent the Highway Rangers in multi-jurisdictional emergency environments.",
    level: "Mastery",
    provider: "highway",
    prerequisiteIds: ["ics-100", "ics-200", "ics-700", "ics-800"],
  },
  {    id: "ics-100",
    title: "ICS-100: Introduction to the Incident Command System",
    focus: "Incident Command",
    summary:
      "Gain an overview of ICS principles, organizational roles, and terminology for highway incident response integration.",
    level: "Required",
    provider: "fema",
    creditHours: 2,
  },
  {
    id: "ics-200",
    title: "ICS-200: Single Resources and Initial Action Incidents",
    focus: "Incident Command",
    summary:
      "Practice applying ICS concepts during expanding incidents, emphasizing chain of command and resource coordination.",
    level: "Core",
    provider: "fema",
    creditHours: 4,
  },
  {
    id: "ics-700",
    title: "ICS-700: National Incident Management System (NIMS)",
    focus: "Incident Command",
    summary:
      "Understand how NIMS establishes common operating frameworks for interagency roadway operations and mutual aid.",
    level: "Advanced",
    provider: "fema",
    creditHours: 4,
  },
  {
    id: "ics-800",
    title: "ICS-800: National Response Framework",
    focus: "Incident Command",
    summary:
      "Connect highway ranger responsibilities to the National Response Framework and nationwide mutual aid coordination.",
    level: "Advanced",
    provider: "fema",
    creditHours: 3,
  },
  {
    id: "national-tim-responder",
    title: "National TIM Responder Training",
    focus: "Responder Safety",
    summary:
      "FHWA's flagship Traffic Incident Management program covering safe, quick clearance tactics across multi-discipline teams.",
    level: "Core",
    provider: "fhwa",
    creditHours: 4,
    url: "https://ops.fhwa.dot.gov/tim/training/tim.htm",
  },
  {
    id: "national-tim-training",
    title: "National TIM Training",
    focus: "Responder Safety",
    summary:
      "Capstone certification for Responder Safety — awarded after completing every core, elective, and advanced module in the Responder Safety curriculum.",
    level: "Capstone",
    provider: "responder",
    track: "regular",
    creditHours: 4,
    prerequisiteIds: [
      "advance-warning",
      "blocking-procedures",
      "high-visibility-innovations",
      "mutcd",
      "move-it-work-it",
      "lighting-awareness",
      "vehicle-fires",
      "special-hazards",
      "termination",
      "tim-ics",
    ],
  },
];

export default trainingModules;
